module.exports = __webpack_public_path__ + "static/media/applied.15707ee1.svg";